import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/Blog.css';
import { blog_Api } from '../../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';
import Footer from '../Components/Footer';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
    const { configUrl } = useSelector((state) => state.cart);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await blog_Api();
        console.log("response : ", response);
        
        if (response.success === true && response.data) {
          const formattedBlogs = response.data.map(blog => ({
            id: blog.id,
            title: blog.title,
            author: blog.author,
            slug: blog.slug,
            date: new Date(blog.published_on).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric'
            }),
            excerpt: blog.short_desc.replace(/<[^>]+>/g, ''), 
            tags: blog.tags.split(',').map(tag => tag.trim()),
            image: blog.image 
          }));
          
          setBlogs(formattedBlogs);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setLoading(false);
      }
    };
    
    fetchBlog();
  }, []);

  return (
   <>
    <div className="blog-list-container">
      <header className="blog-header" style={{marginTop:"80px"}}>
        <h1>Sports Blog</h1>
        <p>Latest news, insights and stories from the world of sports</p>
      </header>

      <div className="blog-grid">
        {loading ? (
          [...Array(4)].map((_, index) => (
            <div key={index} className="blog-card-skeleton">
              <div className="skeleton-image"></div>
              <div className="skeleton-content">
                <div className="skeleton-meta">
                  <span className="skeleton-line short"></span>
                  <span className="skeleton-line short"></span>
                </div>
                <div className="skeleton-line long"></div>
                <div className="skeleton-line medium"></div>
                <div className="skeleton-line medium"></div>
                <div className="skeleton-tags">
                  <span className="skeleton-tag"></span>
                  <span className="skeleton-tag"></span>
                </div>
              </div>
            </div>
          ))
        ) : (
          blogs.map((blog) => (
            <Link 
              to={`/blog/${blog.slug}`} 
              key={blog.id} 
              className="blog-card"
            >
              <div className="blog-image-container">
                <img 
                  src={`${configUrl}${blog.image}`} 
                  alt={blog.title} 
                  className="blog-image"
                  loading="lazy"
                />
                <div className="image-overlay"></div>
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-author">{blog.author}</span>
                  <span className="blog-date">{blog.date}</span>
                </div>
                <h2 className="blog-title">{blog.title}</h2>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-tags">
                  {blog.tags.map((tag, index) => (
                    <span key={index} className="blog-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Blog;